import { useEffect } from 'react';
import "./Support.css";

type SupportProps = {
};

export const Support = ({} : SupportProps) => {
    return (
        <div id="support">
            <div className="help-center-header">
                <div className="page-title">
                    Support
                </div>
            </div>

            <div className="support-body">
                We are here to help 24x7. For support, please contact:
                &nbsp;
                <a href="mailto:support@effno.co">support@effno.co</a>
            </div>
        </div>
    )
}